import React from 'react'

import './CircleIcon.scss'

export default function CircleIcon({ children }) {
  return <div className="circle-icon">{children}</div>
}
